import React, { useEffect } from 'react';
import {useLocation} from "react-router-dom";

const FailPage = () => {
    const location = useLocation();

    const searchParams = new URLSearchParams(location.search);
    const errorMessage = searchParams.get('ErrorText');
    const errorCode = searchParams.get('ErrorCode');
    const env = searchParams.get('userData9');
    const txId = searchParams.get('txId');

    const backendUrl = process.env.REACT_APP_BACKEND_URL;
    
    useEffect(() =>{
        const queryTran = async () => {
            try {
                const response = await fetch(`${backendUrl}/api/qa/query-tran`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ 
                        id: txId,
                        env:env
                    })
                });
    
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
    
                const data = await response.json();
                console.log(data);
            } catch (error) {
                console.log("Something happened: ", error);
            }
        };
        
        queryTran();
    },[])

    let currentUrl = window.location.href;
    console.log(currentUrl);


    return (
        <div className="flex justify-center w-full bg-neutral-50 min-h-screen">
            <div className="flex flex-col items-center px-5 pt-0.5 pb-20 w-full max-w-xs">  {/* max-w-xs is equivalent to max-width: 480px */}
                <img
                    loading="lazy"
                    src={`${process.env.PUBLIC_URL}/logo.png`} // Replace with your actual logo URL
                    alt="Company logo"
                    className="mt-4 w-16 aspect-[1.06]"
                />
                <img
                    loading="lazy"
                    src={`${process.env.PUBLIC_URL}/warning.png`}
                    alt="Error Icon"
                    className="mt-10 max-w-full aspect-square w-[141px]"
                />
                <div className="mt-4 text-xl font-semibold tracking-wide leading-7 text-center text-zinc-600">
                    <span className="text-2xl leading-7">Error Code: {errorCode}</span>
                    <br />
                    <br />
                    <span className="text-lg font-bold underline text-zinc-600">{errorMessage}</span>
                </div>
               {/*  <button onClick={handleRetry} className="justify-center items-center w-full px-6 py-5 mt-36 mb-2 text-lg font-semibold text-white rounded-2xl bg-neutral-900">
                    נסה שוב
                </button> */}
            </div>
        </div>
    );
};
export default FailPage;
